<div class="page-wide">
    <h1>FairBridge Hotels FAQs</h1>

    <div class="content">


        <div ngbAccordion>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>What phone number can I call?</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>For booking questions or customer support, you may reach any property directly by
                            phone using the phone number listed on your reservation or on the booking website for the
                            specific hotel. For all other inquiries, call 877-866-8090 or use the Contact Us form on
                            this website.</ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>What time is check-in and checkout at FairBridge Hotels?</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p> Check-in times usually fall between 3 and 4 p.m., and checkout times are typically
                                between 10
                                and 11 a.m.
                                However, these times are at each hotel’s discretion and based on availability.</p>
                            <p> To find your hotel’s check-in and checkout times, enter your destination in the search
                                bar and
                                navigate to
                                your
                                hotel’s page. On your hotel’s page, you’ll find check-in and checkout information under
                                the
                                Hotel Info
                                section.</p>
                            <p> Your room is guaranteed with a valid credit card, debit card or prepaid card until 7
                                a.m. the
                                morning after
                                your
                                arrival date. This ensures the hotel is holding your room in case of late arrival.
                                However, if
                                your credit
                                or
                                debit card does not have funds available to pay for the room, the room is subject to
                                cancellation. If you’re
                                going to arrive late, please notify the hotel directly.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>Who owns FairBridge Hotels?</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p>
                                FairBridge is an FHS brand with more than 100 locations worldwide. All properties are
                                independently owned
                                and
                                operated by Members of our FairBridge Branded Reservations Network. With more than 7,000
                                rooms
                                under
                                license,
                                FHS offers travelers a wide range of options.</p>


                            <p>Our serviced brand network includes:</p>

                            <ul>
                                <li>FairBridge Inns</li>
                                <li>Loyalty Inns</li>
                                <li>FairBridge Hotels</li>
                                <li>By FairBridge Collection</li>
                                <li>Many fine independent properties.</li>
                            </ul>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>What time is breakfast at FairBridge Hotels?</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p> Free hot breakfast is typically served between 6 and 10 a.m. However, availability
                                breakfast
                                times may vary
                                by
                                property. Please contact your hotel directly for more information about breakfast hours.
                            </p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>How do I connect to WiFi at FairBridge Hotels?</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p> Contact the hotel’s front desk for information on how to connect to their WiFi network.
                                If
                                required, a login
                                and
                                password will be provided upon request.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>Are FairBridge Hotels pet-friendly?</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p> FairBridge has many pet friendly properties throughout the network. Due to state and
                                local laws,
                                the pet
                                policy
                                will vary by location. To see if a hotel accepts pets, look under the Amenities and
                                Policy
                                section in the
                                hotel’s description.</p>


                            <p> Some hotels charge fees such as pet deposits, a nightly surcharge that ranges from $20
                                to $75,
                                or a flat
                                rate
                                surcharge. Limitations on breed or size may apply. Please contact the hotel directly to
                                confirm
                                their
                                specific
                                pet policies and pricing.</p>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>Do FairBridge Hotels have a minimum age requirement?</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p> Some properties may allow reservations to guests ages 19 and older. However, others
                                require you
                                to be at
                                least
                                21 years of age to book rooms. Please contact your property directly for information
                                about their
                                policy.</p>


                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>Is it free to join the FairBridge Rewards Program?</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <p> Yes. It’s free and easy to sign up by visiting our FairBridge Rewards sign up page and
                                entering
                                your email
                                address. You can earn rewards and free nights when you stay at FairBridge Hotels.</p>
                        </ng-template>
                    </div>
                </div>
            </div>


        </div>


    </div>
</div>